import React, { useMemo, useState, useEffect } from "react";
import "../client/Client.css";
import "./Payroll.css";
import { BiExport } from "react-icons/bi";
import PayrollDetail from "./PayrollDetail";
import config from "../../config";
import { FiSearch } from "react-icons/fi";
import { BsSliders } from "react-icons/bs";
import Header from "../../components/common/Header";



const Payroll = ({ setActivePage }) => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;
  const [selectedRow, setSelectedRow] = useState(null);
  const [payrollData, setPayrollData] = useState([]);
  const [loading, setLoading] = useState(true);
  const orgId = localStorage.getItem("orgId") || "";
  const [error, setError] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState('');
  const [clientList, setClientList] = useState([]);
  const [detailLoading, setDetailLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [sortBy, setSortBy] = useState("");



  const [userDetails, setUserDetails] = useState({
    name: "",
    role: "",
    token: "",
    orgId: "",
    clientId: "",
  });


  // Load user details from localStorage
  useEffect(() => {
    const token = localStorage.getItem("Authorization") || "";
    const firstName = localStorage.getItem("firstName") || "";
    const lastName = localStorage.getItem("lastName") || "";
    const role = localStorage.getItem("role")?.toUpperCase() || "GUEST";
    const orgId = localStorage.getItem("orgId") || "6";
    const clientId = localStorage.getItem("clientId") || "3";

    setUserDetails({
      name: `${firstName} ${lastName}`.trim(),
      role,
      token,
      orgId,
      clientId,
    });
  }, []);

  // Fetch payroll data from API
  // Update this useEffect to include sortBy in dependencies and the URL
  // Inside your Payroll component
  useEffect(() => {
    const fetchPayrollData = async () => {
      // Reset error and set loading
      setError(null);
      setPayrollData([]);

      try {
        let sortField = "";
        let sortOrder = "ASC";

        if (sortBy === "newest") {
          sortField = "createdAt";
          sortOrder = "DESC";
        } else if (sortBy === "oldest") {
          sortField = "createdAt";
          sortOrder = "ASC";
        }

        // Check if values exist before fetching
        if (!userDetails.orgId || !selectedClientId) return;

        const url = `${config.API_BASE_URL}${config.PAYROLL_LIST_ENDPOINT}?orgKey=${userDetails.orgId}&clientKey=${selectedClientId}&sortBy=${sortField}&sortOrder=${sortOrder}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${userDetails.token}`,
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (response.ok) {
          // Make sure we are accessing the correct part of your API response (data.body)
          setPayrollData(Array.isArray(data.body) ? data.body : []);
        } else {
          throw new Error(data.message || "Failed to fetch data");
        }
      } catch (err) {
        setError(err.message);
        setPayrollData([]); // Clear data on error
      }
    };

    // Only run if we have the necessary keys
    if (userDetails.token && selectedClientId) {
      fetchPayrollData();
    }
  }, [userDetails.token, userDetails.orgId, selectedClientId, sortBy]);

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const orgId = userDetails.orgId;
        if (!orgId || !userDetails.token) return;

        const response = await fetch(
          `${config.API_BASE_URL}${config.CLIENT_LIST_ENDPOINT}${orgId}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${userDetails.token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch clients");
        }

        const data = await response.json();

        // API response array-ah irukum nu assume panren
        setClientList(Array.isArray(data.body) ? data.body : []);

      } catch (error) {
        console.error("Client fetch error:", error);
        setClientList([]);
      }
    };

    fetchClients();
  }, [userDetails.orgId, userDetails.token]);

  const filtered = useMemo(() => {
    const s = search.trim().toLowerCase();
    if (!s) return payrollData;
    return payrollData.filter(
      (r) =>
        (r.employeeName && r.employeeName.toLowerCase().includes(s)) ||
        (r.jobRole && r.jobRole.toLowerCase().includes(s)) ||
        (r.status && r.status.toLowerCase().includes(s))
    );
  }, [search, payrollData]);
  const sortedData = useMemo(() => {
    let data = [...filtered];

    if (sortBy === "name") {
      data.sort((a, b) => (a.employeeName || "").localeCompare(b.employeeName || ""));
    }

    if (sortBy === "netPayHigh") {
      data.sort((a, b) => (b.netPay || 0) - (a.netPay || 0));
    }

    if (sortBy === "netPayLow") {
      data.sort((a, b) => (a.netPay || 0) - (b.netPay || 0));
    }

    return data;
  }, [filtered, sortBy]);

  const handleRowClick = async (row) => {
    try {
      setDetailLoading(true);

      // Row-la irunthu month matrum year-ai edukkirom
      const month = row.month || "";
      const year = row.year || new Date().getFullYear(); // Row-la year illai na current year edukkum

      const url = `${config.API_BASE_URL}${config.EMPLOYEE_PAYROLL_ENDPOINT}?orgKey=${userDetails.orgId}&clientKey=${selectedClientId}&employeeCode=${row.employeeCode}&month=${month}&year=${year}`;

      console.log("Fetching detail from:", url); // Debugging-kaga

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${userDetails.token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payroll detail");
      }

      const data = await response.json();
      setSelectedRow(data.body);

    } catch (err) {
      console.error("Payroll detail error:", err);
      alert("Unable to load payroll details");
    } finally {
      setDetailLoading(false);
    }
  };


  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const current = sortedData.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.max(1, Math.ceil(sortedData.length / itemsPerPage));

  const handleExport = () => {
    // quick CSV export of the filtered rows
    const headers = [
      "Employee Name",
      "Month",
      "No.Working Day",
      "Job Role",
      "Deduction",
      "Net Pay",
      "Status",
    ];
    const lines = filtered.map((r) =>
      [
        r.employeeName,
        r.month,
        r.workingDays,
        r.jobRole,
        r.deduction,
        r.netPay,
        r.status,
      ].join(",")
    );
    const csv = [headers.join(","), ...lines].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `payroll_export.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  // If a row is selected, show the detail panel overlay
  if (selectedRow) {
    return <PayrollDetail row={selectedRow} onClose={() => setSelectedRow(null)} />;
  }

  return (
    <div>
      <Header
        title="Pay Roll"
        subtitle="Pay Roll Information"
        onProfileClick={() => setActivePage && setActivePage("Profile")}
      />
      {showFilter && (
        <div className="filter-overlay" onClick={() => setShowFilter(false)}>
          <div
            className="filter-card"
            onClick={(e) => e.stopPropagation()}
          >
            <h4>Filter</h4>

            <label>Sort By</label>
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
            >
              <option value=""></option>
              <option value="newest">Newest</option>
              <option value="oldest">Oldest</option>

            </select>

            <div className="filter-buttons">
              <button
                className="clear-btn"
                onClick={() => {
                  setSortBy("");
                  setShowFilter(false);
                }}
              >
                Clear
              </button>

              <button
                className="apply-btn"
                onClick={() => {
                  setShowFilter(false);
                }}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="table-container">
        <div className="table-controls">

          <div className="search-wrapper">
            <FiSearch className="search-icon" />
            <input
              className="search-input-with-icon"
              placeholder="Search"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
          <select
            className="search-input"
            style={{ width: '180px', marginLeft: '430px', marginTop: '18px', height: '38px' }}
            value={selectedClientId}
            onChange={(e) => setSelectedClientId(e.target.value)}
          >
            <option value="">All Clients</option>
            {clientList.map(client => (
              <option key={client.clientKey} value={client.clientKey}>
                {client.name}
              </option>
            ))}
          </select>

          <div className="button-container">
            <button className="export-btn" onClick={handleExport}><BiExport />Export</button>
            <button className="filter-btn" onClick={() => setShowFilter(!showFilter)}>                <BsSliders />
              Filter</button>
          </div>
        </div>

        <table className="table">
          <thead>
            <tr>
                  <th className="th">Employee Name</th>
                  <th className="th">Month</th>
                  <th className="th">No.Working Day</th>
                  <th className="th">Job Role</th>
                  <th className="th">Deduction</th>
                  <th className="th">Net Pay</th>
                  <th className="th">Status</th>
                </tr>
              </thead>
              <tbody>
                {error ? (
                  <tr>
                    <td
                      colSpan="7"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "red",
                        fontSize: "11px",
                        fontWeight: "500",
                        borderTop: "1px solid #eee",
                        borderBottom: "1px solid #eee"
                      }}
                    >
                      {error}
                    </td>
                  </tr>
                ) : current.length > 0 ? (
                  current.map((r, index) => (
                    <tr key={index} onClick={() => handleRowClick(r)} style={{ cursor: "pointer" }}>
                      <td className="td">{r.employeeName || "N/A"}</td>
                      <td className="td">{r.month || "N/A"}</td>
                      <td className="td">{r.noOfWorkingDays || 0}</td>
                      <td className="td">{r.jobRole || "N/A"}</td>
                      <td className="td">₹ {r.totalDeduction || 0}</td>
                      <td className="td">₹ {r.netPay || 0}</td>
                      <td className="td">
                        <span className={`status-pill ${r.status?.toLowerCase() === 'paid' ? 'paid' : 'unpaid'}`}>
                          {r.status || "UNPAID"}
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      style={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#060505ff",
                        fontSize: "11px",
                        fontWeight: "500",
                        borderTop: "1px solid #eee",
                        borderBottom: "1px solid #eee"
                      }}
                    >
                      {selectedClientId
                        ? `No payroll data available for ${clientList.find(c => String(c.clientKey) === String(selectedClientId))?.name || 'this client'}`
                        : "Please select a client to view data"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="table-footer">
              <div className="record-count">
                Showing {filtered.length === 0 ? 0 : indexOfFirst + 1} to {Math.min(indexOfLast, filtered.length)} of {filtered.length} entries
              </div>

              <div className="pagination">
                <button
                  className="pagination-button"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
                >
                  &lt;
                </button>
                {Array.from({ length: totalPages }, (_, i) => (
                  <button
                    key={i}
                    className={`pagination-button ${currentPage === i + 1 ? "active" : ""}`}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}
                <button
                  className="pagination-button"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
                >
                  &gt;
                </button>
              </div>
            </div>
      </div>
    </div>
  );
};

export default Payroll;
